import { render, staticRenderFns } from "./uploadFiles.vue?vue&type=template&id=2cd3921a&scoped=true&"
import script from "./uploadFiles.vue?vue&type=script&lang=js&"
export * from "./uploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./uploadFiles.vue?vue&type=style&index=0&id=2cd3921a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd3921a",
  null
  
)

export default component.exports